import React from "react";
import { Spinner } from "react-bootstrap";

const Button = (props) => {
  const {
    cssClass,
    label,
    clickHandler,
    icon,
    rightIcon,
    isDisabled,
    showLoading,
    btnClass,
    id = null,
  } = props;
  const btnCss = () => {
    // switch (btnType) {
    //     case 'secondary':
    //         return buttonStyle.secondaryBtn;
    //     case 'primary':
    //         return buttonStyle.primaryBtn;
    //     default:
    //         return buttonStyle.primaryBtn;
    // }
  };

  return (
    <>
      <button
        id={id}
        type="button"
        className={`${btnCss()} ${cssClass} ${btnClass}`}
        onClick={clickHandler}
        disabled={isDisabled}
        style={{ cursor: isDisabled ? "not-allowed" : "pointer" }}
      >
        {showLoading ? (
          <Spinner
            className="me-1"
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
          />
        ) : (
          ""
        )}
        {icon && !showLoading && (
          <span className="me-6 d-flex self-center">{icon}</span>
        )}
        {/* {icon && !showLoading && icon} */}
        {label}
        {rightIcon && rightIcon}
      </button>
    </>
  );
};

export default Button;
